module.exports = __webpack_public_path__ + "static/BLOG_230529_UizardAutodesigner-27534337bcf07b3661fa0044eed0fee9.webp";